module.exports = __webpack_public_path__ + "static/media/fundo.d2e8c942.png";